<template>
<div class="date">
  <span class="year">
    <Input placeholder="0000"
      v-model.number="date.year" /></span>
  <span class="text">年</span>
  <template v-if="'month' in date">
    <span class="month">
      <Input placeholder="00"
        v-model.number="date.month" /></span>
    <span class="text">月</span>
  </template>
  <template v-if="'day' in date">
    <span class="day">
      <Input placeholder="00"
        v-model.number="date.day" /></span>
    <span class="text">日</span>
  </template>
  <template v-if="termDate">
    <span>&nbsp;～&nbsp;</span>
    <span class="year">
      <Input placeholder="0000"
        v-model.number="termDate.year" /></span>
    <span class="text">年</span>
    <template v-if="'month' in date">
      <span class="month">
        <Input placeholder="00"
          v-model.number="termDate.month" /></span>
      <span class="text">月</span>
    </template>
    <template v-if="'day' in date">
      <span class="day">
        <Input placeholder="00"
          v-model.number="termDate.day" /></span>
      <span class="text">日</span>
    </template>
  </template>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['date', 'termDate'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
